import React from 'react';
import {GoogleLogin} from '@leecheuk/react-google-login';

const clientId = process.env.REACT_APP_CLIENT_ID;

class Login extends React.Component {
    handleLoginSuccess = (authData) => {
        this.props.handleLoggedIn(authData.profileObj);
        localStorage.setItem('user', JSON.stringify(authData.profileObj));
        localStorage.setItem('token', JSON.stringify(authData.tokenObj))
    };

    handleLoginFailure = (error) => {
        console.log('Google login error:', error);
    };

    isTokenValid = (token) => {
        if(token == null) return false
        return new Date() < new Date(JSON.parse(token).expires_at);
    }

    componentDidMount() {
        const user = localStorage.getItem('user')
        const token = localStorage.getItem('token');

        if (user != null && this.isTokenValid(token)) {
            this.props.handleLoggedIn(JSON.parse(user));
        } else {
            localStorage.removeItem('user')
            localStorage.removeItem('token')
        }
    }

    render() {
        return (
            <GoogleLogin className="m-1"
                clientId={clientId}
                onSuccess={this.handleLoginSuccess}
                onFailure={this.handleLoginFailure}
                buttonText="LOGIN"
                cookiePolicy={'single_host_origin'}
            />
        );
    }
}

export default Login;